import { render, staticRenderFns } from "./PrometBase.vue?vue&type=template&id=4d7b661e&scoped=true&"
import script from "./PrometBase.vue?vue&type=script&lang=js&"
export * from "./PrometBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b661e",
  null
  
)

export default component.exports